import { HttpProviderFactory } from './http/http-provider.factory';
import { IAppConfig } from './http/types/IApplicationConfig';
import { SpinnerService } from './SpinnerService';

import { AuthenticationService } from './AuthenticationService/authentication.service';
import { AuthenticationServiceFactory } from './AuthenticationService/authentication.service.factory';

import { AuthStatusService } from './AuthStatusService/auth-status.service';
import { AuthStatusServiceFactory } from './AuthStatusService/auth-status.service.factory';

import { ConfigService } from './ConfigService/config.service';
import { ConfigServiceFactory } from './ConfigService/config.service.factory';

import { InitializationService } from './Initialization/initialization.service';
import { InitializationServiceFactory } from './Initialization/initialization.service.factory';
import { InitializationModel } from './Initialization/initialization.model';

import { EmployeeInitializationService } from './Initialization/employee-initialization.service';
import { EmployeeInitializationServiceFactory } from './Initialization/employee-initialization.service.factory';


import { AccountManagerService } from './AccountManagerService/account.manager.service';
import { AccountManagerServiceFactory } from './AccountManagerService/account.manager.service.factory';

import { AccountingService } from './AccountingService/accounting.service';
import { AccountingServiceFactory } from './AccountingService/accounting.service.factory';

import { AnouncementService } from './AccouncementService/anouncement.service';
import { AnouncementServiceFactory } from './AccouncementService/anouncement.service.factory';

import { BenchEmployeeService } from './BenchEmployeeService/bench-employee.service';
import { BenchEmployeeServiceFactory } from './BenchEmployeeService/bench-employee.service.factory';

import { ClientService } from './ClientService/client.service';
import { ClientServiceFactory } from './ClientService/client.service.factory';

import { DashboardService } from './Dashboard/dashboard.service';
import { DashboardServiceFactory } from './Dashboard/dashboard.service.factory';

import { DemandService } from './DemandService/demand.service';
import { DemandServiceFactory } from './DemandService/demand.service.factory';

import { DemandRoleService } from './DemandRoleService/demand-role.service';
import { DemandRoleServiceFactory } from './DemandRoleService/demand-role.service.factory';

import { DownloadService } from './downloadService/download.service';
import { DownloadServiceFactory } from './downloadService/download.service.factory';

import { EmailService } from './EmailService/email.service';
import { EmailServiceFactory } from './EmailService/email.service.factory';

import { EmailAccountService } from './EmailAccountService/email-account.service';
import { EmailAccountServiceFactory } from './EmailAccountService/email-account.service.factory';

import { EmployeeService } from './EmployeeService/employee.service';
import { EmployeeServiceFactory } from './EmployeeService/employee.service.factory';

import { EmployeeSideService } from './EmployeeSideService/employee-side.service';
import { EmployeeSideServiceFactory } from './EmployeeSideService/employee-side.service.factory';

import { HelpDeskService } from './HelpdeskService/helpdesk.service';
import { HelpDeskServiceFactory } from './HelpdeskService/helpdesk.service.factory';

import { HMFlowService } from './HMFlowService/hmFlow.service';
import { HMFlowServiceFactory } from './HMFlowService/hmFlow.service.factory';

import { ImmigrationService } from './Immigration/immigration.service';
import { ImmigrationServiceFactory } from './Immigration/immigration.service.factory';

import { InsuranceProviderService } from './InsuranceProviderService/insuranceProvider.service';
import { InsuranceProviderServiceFactory } from './InsuranceProviderService/insuranceProvider.service.factory';

import { InvoiceService } from './InvoiceService/invoice.service';
import { InvoiceServiceFactory } from './InvoiceService/invoice.service.factory';

import { PayrollService } from './payroll/payroll.service';
import { PayrollServiceFactory } from './payroll/payroll.service.factory';

import { ProjectService } from './ProjectService/project.service';
import { ProjectServiceFactory } from './ProjectService/project.service.factory';

import { PropertyService } from './PropertyService/property.service';
import { PropertyServiceFactory } from './PropertyService/property.service.factory';

import { ResourceService } from './ResourceService/resource.service';
import { ResourceServiceFactory } from './ResourceService/resource.service.factory';

import { SalesRepService } from './SalesRepService/salesrep.service';
import { SalesRepServiceFactory } from './SalesRepService/salesrep.service.factory';

import { UserManagementService } from './UserManagementService/userManagement.service';
import { UserManagementServiceFactory } from './UserManagementService/userManagement.service.factory';

import { UserService } from './UserService/user.service';
import { UserServiceFactory } from './UserService/user.service.factory';

import { VendorService } from './VendorService/vendor.service';
import { VendorServiceFactory } from './VendorService/vendor.service.factory';

import { TimeSheetService } from './TimeSheetService/timesheet.service';
import { TimeSheetServiceFactory } from './TimeSheetService/timesheet.service.factory';

import {AttendanceService} from './AttendanceService/attendance.service';
import {AttendanceServiceFactory} from './AttendanceService/attendance.service.factory';


export class ServiceLocator {
    private static instance: ServiceLocator;
    private config: IAppConfig;
    private spinnerService: SpinnerService;
    private initializationModel: InitializationModel;

    // Tier 1 - base
    private authService: AuthenticationService | null = null;
    private configService: ConfigService | null = null;

    // Tier 2 - depend on auth
    private authStatusService: AuthStatusService | null = null;
    private accountManagerService: AccountManagerService | null = null;
    private accountingService: AccountingService | null = null;
    private anouncementService: AnouncementService | null = null;
    private benchEmployeeService: BenchEmployeeService | null = null;
    private clientService: ClientService | null = null;
    private dashboardService: DashboardService | null = null;
    private demandService: DemandService | null = null;
    private demandRoleService: DemandRoleService | null = null;
    private downloadService: DownloadService | null = null;
    private emailService: EmailService | null = null;
    private emailAccountService: EmailAccountService | null = null;
    private employeeService: EmployeeService | null = null;
    private employeeSideService: EmployeeSideService | null = null;
    private attendanceService : AttendanceService | null = null;
    private helpDeskService: HelpDeskService | null = null;
    private hmFlowService: HMFlowService | null = null;
    private immigrationService: ImmigrationService | null = null;
    private insuranceProviderService: InsuranceProviderService | null = null;
    private invoiceService: InvoiceService | null = null;
    private payrollService: PayrollService | null = null;
    private propertyService: PropertyService | null = null;
    private resourceService: ResourceService | null = null;
    private salesRepService: SalesRepService | null = null;
    private userManagementService: UserManagementService | null = null;
    private userService: UserService | null = null;
    private vendorService: VendorService | null = null;
    private timeSheetService: TimeSheetService | null = null;


    // Tier 3 - depend on multiple services
    private projectService: ProjectService | null = null;
    private initializationService: InitializationService | null = null;
    private employeeInitializationService: EmployeeInitializationService | null = null;


    private constructor(config: IAppConfig, spinnerService: SpinnerService) {
        this.config = config;
        this.spinnerService = spinnerService;
        this.initializationModel = new InitializationModel();
        HttpProviderFactory.create(config, spinnerService);
    }

    static initialize(config: IAppConfig, spinnerService?: SpinnerService): void {
        if (!ServiceLocator.instance) {
            const spinner = spinnerService || new SpinnerService();
            ServiceLocator.instance = new ServiceLocator(config, spinner);
        }
    }

    static getInstance(): ServiceLocator {
        if (!ServiceLocator.instance) {
            throw new Error('ServiceLocator not initialized. Call ServiceLocator.initialize(config) first.');
        }
        return ServiceLocator.instance;
    }

    // ??? Tier 1 ???????????????????????????????????????????????????????????????

    // ??? Tier 1 ???????????????????????????????????????????????????????????????

    getSpinnerService(): SpinnerService {
        return this.spinnerService;
    }

    getAuthenticationService(): AuthenticationService {
        if (!this.authService) {
            this.authService = AuthenticationServiceFactory.create(this.config, this.spinnerService);
        }
        return this.authService;
    }

    getConfigService(): ConfigService {
        if (!this.configService) {
            this.configService = ConfigServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.configService;
    }

    // ??? Tier 2 ???????????????????????????????????????????????????????????????

    getAuthStatusService(): AuthStatusService {
        if (!this.authStatusService) {
            this.authStatusService = AuthStatusServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.authStatusService;
    }

    getAccountManagerService(): AccountManagerService {
        if (!this.accountManagerService) {
            this.accountManagerService = AccountManagerServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.accountManagerService;
    }

    getAccountingService(): AccountingService {
        if (!this.accountingService) {
            this.accountingService = AccountingServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.accountingService;
    }

    getAnouncementService(): AnouncementService {
        if (!this.anouncementService) {
            this.anouncementService = AnouncementServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.anouncementService;
    }

    getBenchEmployeeService(): BenchEmployeeService {
        if (!this.benchEmployeeService) {
            this.benchEmployeeService = BenchEmployeeServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.benchEmployeeService;
    }

    getClientService(): ClientService {
        if (!this.clientService) {
            this.clientService = ClientServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.clientService;
    }

    getDashboardService(): DashboardService {
        if (!this.dashboardService) {
            this.dashboardService = DashboardServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.dashboardService;
    }

    getDemandService(): DemandService {
        if (!this.demandService) {
            this.demandService = DemandServiceFactory.create(this.config, this.spinnerService);
        }
        return this.demandService;
    }

    getDemandRoleService(): DemandRoleService {
        if (!this.demandRoleService) {
            this.demandRoleService = DemandRoleServiceFactory.create(this.config, this.spinnerService);
        }
        return this.demandRoleService;
    }

    getDownloadService(): DownloadService {
        if (!this.downloadService) {
            this.downloadService = DownloadServiceFactory.create(this.config, this.spinnerService);
        }
        return this.downloadService;
    }

    getEmailService(): EmailService {
        if (!this.emailService) {
            this.emailService = EmailServiceFactory.create(this.config, this.spinnerService);
        }
        return this.emailService;
    }

    getEmailAccountService(): EmailAccountService {
        if (!this.emailAccountService) {
            this.emailAccountService = EmailAccountServiceFactory.create(this.config, this.spinnerService);
        }
        return this.emailAccountService;
    }

    getEmployeeService(): EmployeeService {
        if (!this.employeeService) {
            this.employeeService = EmployeeServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService(),this.initializationModel
            );
        }
        return this.employeeService;
    }

    getEmployeeSideService(): EmployeeSideService {
        if (!this.employeeSideService) {
            this.employeeSideService = EmployeeSideServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.employeeSideService;
    }

    getAttendanceService(): AttendanceService {
        if (!this.attendanceService) {
            this.attendanceService = AttendanceServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.attendanceService;
    }

    getHelpDeskService(): HelpDeskService {
        if (!this.helpDeskService) {
            this.helpDeskService = HelpDeskServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.helpDeskService;
    }

    getHMFlowService(): HMFlowService {
        if (!this.hmFlowService) {
            this.hmFlowService = HMFlowServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService(), this.getConfigService()
            );
        }
        return this.hmFlowService;
    }

    getImmigrationService(): ImmigrationService {
        if (!this.immigrationService) {
            this.immigrationService = ImmigrationServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.immigrationService;
    }

    getInsuranceProviderService(): InsuranceProviderService {
        if (!this.insuranceProviderService) {
            this.insuranceProviderService = InsuranceProviderServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.insuranceProviderService;
    }

    getInvoiceService(): InvoiceService {
        if (!this.invoiceService) {
            this.invoiceService = InvoiceServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.invoiceService;
    }

    getPayrollService(): PayrollService {
        if (!this.payrollService) {
            this.payrollService = PayrollServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.payrollService;
    }

    getPropertyService(): PropertyService {
        if (!this.propertyService) {
            this.propertyService = PropertyServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.propertyService;
    }

    getResourceService(): ResourceService {
        if (!this.resourceService) {
            this.resourceService = ResourceServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.resourceService;
    }

    getSalesRepService(): SalesRepService {
        if (!this.salesRepService) {
            this.salesRepService = SalesRepServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.salesRepService;
    }

    getUserManagementService(): UserManagementService {
        if (!this.userManagementService) {
            this.userManagementService = UserManagementServiceFactory.create(
                this.config, this.spinnerService,this.getAuthenticationService(),this.getConfigService()
            );
        }
        return this.userManagementService;
    }

    getUserService(): UserService {
        if (!this.userService) {
            this.userService = UserServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.userService;
    }

    getVendorService(): VendorService {
        if (!this.vendorService) {
            this.vendorService = VendorServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.vendorService;
    }

    getTimeSheetService(): TimeSheetService {
        if (!this.timeSheetService) {
            this.timeSheetService = TimeSheetServiceFactory.create(
                this.config, this.spinnerService, this.getAuthenticationService()
            );
        }
        return this.timeSheetService;
    }


    // ??? Tier 3 ???????????????????????????????????????????????????????????????

    getProjectService(): ProjectService {
        if (!this.projectService) {
            this.projectService = ProjectServiceFactory.create(
                this.config, this.spinnerService,
                this.getAuthenticationService(),
                this.getEmployeeService()
            );
        }
        return this.projectService;
    }

    getInitializationService(): InitializationService {
        if (!this.initializationService) {
            this.initializationService = InitializationServiceFactory.create(
                this.config, this.spinnerService,
                this.getAuthenticationService(),
                this.getConfigService(),
                this.initializationModel,
                this.getAuthStatusService(),
                this.getAccountManagerService()
            );
        }
        return this.initializationService;
    }

    getEmployeeInitializationService(): EmployeeInitializationService {
        if (!this.employeeInitializationService) {
            this.employeeInitializationService = EmployeeInitializationServiceFactory.create(
                this.config, this.spinnerService,
                this.getAuthenticationService(),
                this.getConfigService(),
                this.initializationModel,
                this.getAuthStatusService(),
                this.getEmployeeSideService()
            );
        }
        return this.employeeInitializationService;
    }


    // ??? Lifecycle ????????????????????????????????????????????????????????????

    resetServices(): void {
        this.authService = null;
        this.configService = null;
        this.authStatusService = null;
        this.accountManagerService = null;
        this.accountingService = null;
        this.anouncementService = null;
        this.benchEmployeeService = null;
        this.clientService = null;
        this.dashboardService = null;
        this.demandService = null;
        this.demandRoleService = null;
        this.downloadService = null;
        this.emailService = null;
        this.employeeService = null;
        this.employeeSideService = null;
        this.helpDeskService = null;
        this.hmFlowService = null;
        this.immigrationService = null;
        this.insuranceProviderService = null;
        this.invoiceService = null;
        this.payrollService = null;
        this.projectService = null;
        this.propertyService = null;
        this.resourceService = null;
        this.salesRepService = null;
        this.userManagementService = null;
        this.userService = null;
        this.vendorService = null;
        this.timeSheetService = null;
        this.initializationService = null;
        this.employeeInitializationService = null;
        this.initializationModel = new InitializationModel();

    }

    static destroy(): void {
        if (ServiceLocator.instance) {
            ServiceLocator.instance.resetServices();
            HttpProviderFactory.reset();
            ServiceLocator.instance = null as any;
        }
    }

    static getStats() {
        return {
            isInitialized: ServiceLocator.instance !== null,
            httpProviderInitialized: HttpProviderFactory.isInitialized(),
            httpProviderStats: HttpProviderFactory.getStats()
        };
    }
}
